import GuestIcon from '@material-ui/icons/ViewList';

import GuestList from './GuestList';

export default {
  list: GuestList,
  icon: GuestIcon,
};
